import type {FC} from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import {checkIfLinkShouldUseAnchorTag} from 'utils';

import type {FeaturedLinkSchema} from 'components/content-blocks/featured-links/schema';

interface Props {
	href?: string;
	targetBlank?: boolean;
	text?: string;
	title?: string;
	tagline?: string;
	theme?: FeaturedLinkSchema['theme'];
}

export const FeaturedLinkRender: FC<Props> = ({href, targetBlank, text, title, tagline, theme}) => {
	const linkShouldUseAnchorTag = checkIfLinkShouldUseAnchorTag(href);
	const className = clsx(
		theme === 'red' ? 'bg-red-main' : 'bg-blue-main',
		theme === 'red' ? 'hover:bg-red-light' : 'hover:bg-blue-light',
		'inline-block',
		'text-center',
		'transition-colors',
		'py-3',
		'px-4',
		'md:px-8',
	);

	const link = linkShouldUseAnchorTag ? (
		<a className={className} href={href ?? '#'} target={targetBlank ? '_blank' : undefined}>
			{text}
		</a>
	) : (
		<Link className={className} href={href ?? '#'} target={targetBlank ? '_blank' : undefined}>
			{text}
		</Link>
	);

	return (
		<div
			className={clsx(
				'flex',
				'items-center',
				'justify-center',
				'p-10',
				'md:p-20',
				theme === 'red' ? 'bg-red-light' : 'bg-blue-light',
				theme === 'red' ? 'bg-cake' : 'bg-catering',
			)}
		>
			<div
				className={clsx(
					'flex',
					'flex-col',
					'justify-center',
					'items-center',
					'bg-white',
					'px-8',
					'py-6',
					'md:px-16',
					'md:py-12',
					'w-full',
				)}
			>
				<h2
					className={clsx(
						'text-2xl',
						'md:text-4xl',
						'font-bold',
						'tracking-tight',
						'text-primary-main',
						'uppercase',
						'mb-4',
						'font-din-condensed',
					)}
				>
					{title}
				</h2>
				<div className={clsx('md:text-lg', 'mb-6')}>{tagline}</div>
				{link}
			</div>
		</div>
	);
};
